import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7864b85e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-container" }
const _hoisted_2 = { class: "chat-card" }
const _hoisted_3 = { class: "chat-section" }
const _hoisted_4 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_5 = {
  key: 1,
  class: "chat-wrapper"
}
const _hoisted_6 = { class: "chat-window" }
const _hoisted_7 = { class: "chat-header" }
const _hoisted_8 = {
  key: 0,
  class: "chat-header-service"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "chat-header-name" }
const _hoisted_11 = {
  key: 1,
  class: "chat-header-1v1"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "chat-header-info" }
const _hoisted_14 = { class: "chat-header-name" }
const _hoisted_15 = {
  key: 0,
  class: "chat-header-title"
}
const _hoisted_16 = { class: "load-more-wrapper" }
const _hoisted_17 = {
  key: 1,
  class: "loading-history"
}
const _hoisted_18 = {
  key: 0,
  class: "time-separator"
}
const _hoisted_19 = {
  key: 1,
  class: "recalled-row"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "message-content-wrapper" }
const _hoisted_24 = { class: "message-info" }
const _hoisted_25 = {
  key: 0,
  class: "message-bubble"
}
const _hoisted_26 = { class: "image-content" }
const _hoisted_27 = {
  key: 1,
  class: "file-message"
}
const _hoisted_28 = { class: "message-bubble" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 2,
  class: "message-bubble"
}
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = { class: "input-area-wrapper" }
const _hoisted_33 = { class: "input-box" }
const _hoisted_34 = { class: "toolbar" }
const _hoisted_35 = { class: "emoji-picker" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["src", "alt"]
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "action-bar" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("发送")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FdLoading = _resolveComponent("FdLoading")!
  const _component_ChatWhatsApp = _resolveComponent("ChatWhatsApp")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_ChatFileAttachment = _resolveComponent("ChatFileAttachment")!
  const _component_SmileOutlined = _resolveComponent("SmileOutlined")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_PictureOutlined = _resolveComponent("PictureOutlined")!
  const _component_PaperClipOutlined = _resolveComponent("PaperClipOutlined")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.initLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_FdLoading)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.isCustomerServiceMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_ctx.serviceHeadPortrait)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "chat-header-avatar",
                              src: _ctx.serviceHeadPortrait,
                              alt: ""
                            }, null, 8, _hoisted_9))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.serviceNickName), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_ctx.adviserHeadPortrait)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "chat-header-avatar",
                              src: _ctx.adviserHeadPortrait,
                              alt: ""
                            }, null, 8, _hoisted_12))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.adviserNickName), 1),
                          (_ctx.adviserTitle)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.adviserTitle), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.enableWhatsApp)
                          ? (_openBlock(), _createBlock(_component_ChatWhatsApp, {
                              key: 1,
                              "customer-uid": _ctx.currentUserInfo.uid,
                              "adviser-name": _ctx.adviserNickName,
                              "adviser-title": _ctx.adviserTitle,
                              onAdviserInfo: _ctx.handleAdviserInfo
                            }, null, 8, ["customer-uid", "adviser-name", "adviser-title", "onAdviserInfo"]))
                          : _createCommentVNode("", true)
                      ]))
                ]),
                _createElementVNode("div", {
                  class: "message-list",
                  ref: "messageListRef",
                  onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    (_ctx.hasMoreHistory && !_ctx.isLoadingHistory && _ctx.messages.length > 0)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "load-more-text",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLoadMore && _ctx.handleLoadMore(...args)))
                        }, " 加载更多 "))
                      : _createCommentVNode("", true),
                    (_ctx.isLoadingHistory)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_FdLoading)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: msg.id || index,
                      class: "message-row"
                    }, [
                      (_ctx.shouldShowTime(index))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.formatTime(msg.time)), 1))
                        : _createCommentVNode("", true),
                      (msg.isRecalled)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 撤回一条消息 "))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass(['message-item', msg.isMe ? 'my-message' : 'other-message'])
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["avatar", { 'service-avatar': !msg.isMe }])
                            }, [
                              (_ctx.getMessageAvatar(msg))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.getMessageAvatar(msg)
                                  }, null, 8, _hoisted_20))
                                : (msg.from.length > 2)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(msg.from.slice(-2)), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(msg.from), 1))
                            ], 2),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["name", { 'service-name': !msg.isMe }])
                                }, _toDisplayString(_ctx.getDisplayName(msg)), 3)
                              ]),
                              (msg.type === 'img' && msg.url)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createElementVNode("div", _hoisted_26, [
                                      _createVNode(_component_a_image, {
                                        src: msg.url,
                                        preview: true
                                      }, null, 8, ["src"])
                                    ])
                                  ]))
                                : ((msg.type === 'file' || msg.type === 'pdf' || msg.type === 'video') && msg.url)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                      _createElementVNode("div", _hoisted_28, [
                                        _createVNode(_component_ChatFileAttachment, {
                                          url: msg.url,
                                          "file-name": msg.fileName,
                                          "msg-type": msg.type
                                        }, null, 8, ["url", "file-name", "msg-type"])
                                      ]),
                                      _createElementVNode("span", {
                                        class: "file-download-link",
                                        onClick: ($event: any) => (_ctx.handleFileDownload(msg))
                                      }, "下载", 8, _hoisted_29)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["text", { 'emoji-text': _ctx.useEmojiImage }]),
                                        innerHTML: _ctx.parseEmoji(msg.msg)
                                      }, null, 10, _hoisted_31)
                                    ]))
                            ])
                          ], 2))
                    ]))
                  }), 128))
                ], 544),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      (_ctx.supportsEmoji)
                        ? (_openBlock(), _createBlock(_component_a_popover, {
                            key: 0,
                            visible: _ctx.showEmoji,
                            "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showEmoji) = $event)),
                            trigger: "click",
                            placement: "topLeft",
                            overlayClassName: "emoji-popover"
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("div", _hoisted_35, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emojiList, (emoji) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: emoji,
                                    class: "emoji-item",
                                    onClick: ($event: any) => (_ctx.handleEmojiClick(emoji))
                                  }, [
                                    (_ctx.useEmojiImage)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: _ctx.emojiToImage(emoji),
                                          alt: emoji,
                                          class: "emoji-picker-img"
                                        }, null, 8, _hoisted_37))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(emoji), 1))
                                  ], 8, _hoisted_36))
                                }), 128))
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_SmileOutlined, { class: "toolbar-icon" })
                            ]),
                            _: 1
                          }, 8, ["visible"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_PictureOutlined, {
                        class: "toolbar-icon",
                        onClick: _ctx.handleImageUpload
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_PaperClipOutlined, {
                        class: "toolbar-icon",
                        onClick: _ctx.handleDocUpload
                      }, null, 8, ["onClick"]),
                      _createElementVNode("input", {
                        type: "file",
                        ref: "fileInput",
                        style: {"display":"none"},
                        accept: "image/*",
                        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onImageSelected && _ctx.onImageSelected(...args)))
                      }, null, 544),
                      _createElementVNode("input", {
                        type: "file",
                        ref: "docFileInput",
                        style: {"display":"none"},
                        onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onDocFileSelected && _ctx.onDocFileSelected(...args)))
                      }, null, 544)
                    ]),
                    _createVNode(_component_a_textarea, {
                      class: "chat-textarea",
                      ref: "textareaRef",
                      value: _ctx.inputText,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputText) = $event)),
                      rows: 3,
                      onPressEnter: _ctx.handleSend,
                      placeholder: "请输入消息...",
                      disabled: !_ctx.isConnected,
                      bordered: false
                    }, null, 8, ["value", "onPressEnter", "disabled"]),
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        class: "send-btn",
                        onClick: _ctx.handleSend,
                        loading: _ctx.sending
                      }, {
                        default: _withCtx(() => [
                          _hoisted_40
                        ]),
                        _: 1
                      }, 8, ["onClick", "loading"])
                    ])
                  ])
                ])
              ])
            ]))
      ])
    ])
  ]))
}